import { render, staticRenderFns } from "./PayrollCode.vue?vue&type=template&id=5280845b&scoped=true&"
import script from "./PayrollCode.vue?vue&type=script&lang=js&"
export * from "./PayrollCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280845b",
  null
  
)

export default component.exports